import { Box, Typography } from "@mui/material";
import theme from "../../../theme";
import { useTranslation } from "react-i18next";

// Timer widget style
const timeBoxStyles = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  // backgroundColor: "#000",
  color: theme.palette.text.secondary,
  padding: "0.5rem 1rem",
  textAlign: "left",
  width: "32%",
};

// Divider style with gradient fade
const dividerStyles = {
  width: "1px",
  height: "2rem",
  // background: "white",
  background: `linear-gradient(to bottom, transparent, ${theme.palette.text.secondary}, transparent)`,
  alignSelf: "center",
  // opacity: 1,
};

const TimerWidget = ({ hours, mins, seconds }) => {
  const { t } = useTranslation("common");

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        backgroundColor: theme.palette.text.primary,
        borderRadius: "0.75rem",
      }}
    >
      <Box sx={timeBoxStyles}>
        <Typography variant="h6" color="text.secondary">
          {`${hours < 10 ? `0${hours}` : hours}`}
        </Typography>
        <Typography fontSize="0.85rem" fontWeight="600" color="text.secondary">
          {t("Hours")}
        </Typography>
      </Box>

      <Box sx={dividerStyles} />

      <Box sx={timeBoxStyles}>
        <Typography variant="h6" color="text.secondary">
          {`${mins < 10 ? `0${mins}` : mins}`}
        </Typography>
        <Typography fontSize="0.85rem" fontWeight="600" color="text.secondary">
          {t("Minutes")}
        </Typography>
      </Box>

      <Box sx={dividerStyles} />

      <Box sx={timeBoxStyles}>
        <Typography variant="h6" color="text.secondary">
          {`${seconds < 10 ? `0${seconds}` : seconds}`}
        </Typography>
        <Typography fontSize="0.85rem" fontWeight="600" color="text.secondary">
          {t("Seconds")}
        </Typography>
      </Box>
    </Box>
  );
};

export default TimerWidget;